export default {
  copyButton: {
    padding: '6px',
    '.copy-icon': {
      width: '18px',
      height: '18px',
    },
    ':hover': {
      '.copy-icon-path': {
        stroke: (theme) => theme.palette.primary.main,
      },
    },
  },
};
